export default __webpack_public_path__ + "static/media/dashboard.e786f45e.svg";